(function ($, Drupal, once) {
  Drupal.behaviors.beforeAfterCompare = {
    attach(context) {

      if (window.innerWidth >= 992) {
        return;
      }

      once('before-after-compare', '.images-compare-container', context).forEach(function (container) {

        const $container = $(container);

        let dragging = false;

        /**
         * Update slider position.
         */
        function update(clientX) {

          const rect = container.getBoundingClientRect();

          let percent = ((clientX - rect.left) / rect.width) * 100;

          percent = Math.max(0, Math.min(100, percent));

          container.style.setProperty('--compare-position', percent + '%');
        }

        // Initial position.
        update(container.getBoundingClientRect().left + (container.offsetWidth / 2));

        $container.on('pointerdown', function (e) {
          dragging = true;
          update(e.clientX);
        });

        $(window).on('pointermove.beforeAfterCompare', function (e) {

          if (!dragging) {
            return;
          }

          update(e.clientX);

        });

        $(window).on('pointerup.beforeAfterCompare pointercancel.beforeAfterCompare', function () {
          dragging = false;
        });

      });

    }
  };

})(jQuery, Drupal, once);